import React from 'react'
import './FreeCourseBanner.scss'
import { Link } from 'react-router-dom'
import { classes } from '../../services/utils'
import { routesURLs } from '../../Routes'
import { useQuery } from 'react-query'
import { Settings } from '../../services/types'
import { getSettings } from '../../moduls/settings'
import { getBannerCourseLink } from '../../services/utils'
import { useHistory } from 'react-router-dom'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const sliderSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000
}
const FreeCourseBanner: React.FC<{ className?: string; courses: any }> = ({
  className = '',
  courses
}) => {
  let isOnlyOutside = false
  const history = useHistory()

  if (
    courses &&
    courses?.onsite_courses?.length &&
    !courses?.online_courses?.length &&
    !courses?.online_mock_exam_courses?.length &&
    !courses?.onsite_tests?.length
  ) {
    isOnlyOutside = true
  }

  const { data: settings, isLoading: settingsLoading } = useQuery<Settings>(
    ['settings'],
    getSettings
  )

  if (settingsLoading) {
    return null
  }

  return (
    <div
      className={classes(`free-course-banner ${!settings?.banners.length && 'flex'}`, {
        [className || '']: !!className
      })}
    >
      {settings?.banners.length ? (
        <Slider {...sliderSettings}>
          {settings?.banners.map((banner) => (
            <div key={banner.title} className="free-course-banner-dynamic">
              <div className="free-course-banner-dynamic-text">
                <h2>{banner.title}</h2>
                <span className="someFreeLessons">{banner.subtitle}</span>
              </div>
              <span
                onClick={() =>
                  history.push(
                    getBannerCourseLink(
                      banner.course.id,
                      banner.course.type,
                      banner.course.course_key,
                      banner.course.subject_id,
                      banner.course.lesson_class_id,
                      banner.course.city_id
                    )
                  )
                }
                className="button is-primary"
              >
                Vyzkoušet
              </span>
            </div>
          ))}
        </Slider>
      ) : (
        <>
          <div className="free-course-banner-content">
            {!isOnlyOutside ? (
              <span>
                <h2>Vyzkoušejte si další on-line kurz</h2>
                <span className="someFreeLessons">
                  V každém kurzu pro Vás máme několik lekcí zcela zdarma.
                </span>
              </span>
            ) : (
              <h2>Vyzkoušejte naše on-line kurzy zdarma!</h2>
            )}
          </div>
          <Link to={routesURLs.onlineCourses} className="button is-primary">
            Vyzkoušet
          </Link>
        </>
      )}
    </div>
  )
}

export default FreeCourseBanner
